import React, { useState } from 'react'
import { Box, Button, Divider, Grid, IconButton, InputAdornment, TextField } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useFormik } from "formik"
import * as yup from "yup"
import { register } from '../../store/features/user/userSlice'
import { Google, Visibility, VisibilityOff } from '@mui/icons-material'

const Register = () => {
    const [visible, setVisible] = useState(false)
    const navigate=useNavigate();
    const dispatch=useDispatch();

    const handleVisible = () => {
        setVisible(!visible)
    }

    let registerSchema = yup.object({
        name: yup.string().required("Name is Required"),
        email: yup.string().email("Email Should be valid").required("Email is Required"),
        phone: yup.string().required("Phone Number is Required"),
        password: yup.string().required("Password is Required")
      })
      const formik = useFormik({
        initialValues: {
          name: "",
          email: "",
          phone: "",
          password: "",
        },
        validationSchema: registerSchema,
        onSubmit: (values) => {
          dispatch(register(values))
        }
    })

    const handleNavigate = () => {
        navigate("/login")
    }
    
  return (
    <div className='bg-blue-950 border-blue-800 w-[350px] sm:w-[500px] mt-[150px] mb-12 mx-auto p-8 border rounded-md shadow-md'>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField
                    id='name'
                    name='name'
                    label='Name'
                    fullWidth
                    autoComplete='given-name'
                    onChange={formik.handleChange("name")}
                    value={formik.values.name}
                    onBlur={formik.handleBlur("name")}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.name && formik.errors.name ? (
                        <div>{formik.errors.name}</div>
                    ) : null}
                </Box>
            </Grid>
            <Grid item xs={12} >
                <TextField
                    type='email'
                    id='email'
                    name='email'
                    label='Email'
                    fullWidth
                    autoComplete='given-email'
                    onChange={formik.handleChange("email")}
                    value={formik.values.email}
                    onBlur={formik.handleBlur("email")}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.email && formik.errors.email ? (
                        <div>{formik.errors.email}</div>
                    ) : null}
                </Box>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    type='number'
                    id='phone'
                    name='phone'
                    label='Phone Number'
                    fullWidth
                    autoComplete='given-number'
                    onChange={formik.handleChange("phone")}
                    value={formik.values.phone}
                    onBlur={formik.handleBlur("phone")}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.phone && formik.errors.phone ? (
                        <div>{formik.errors.phone}</div>
                    ) : null}
                </Box>
            </Grid>
            <Grid item xs={12} >
                <TextField
                    type={visible ? 'text' : 'password'}
                    id='password'
                    name='password'
                    label='Password'
                    fullWidth
                    autoComplete='password'
                    onChange={formik.handleChange("password")}
                    value={formik.values.password}
                    onBlur={formik.handleBlur("password")}
                    InputProps={{
                        endAdornment:(
                            <InputAdornment>
                                <IconButton edge='end' onClick={handleVisible}>
                                    {visible ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.password && formik.errors.password ? (
                        <div>{formik.errors.password}</div>
                    ) : null}
                </Box>
            </Grid>
            <Grid item xs={12} >
                <Button
                    onClick={handleNavigate}
                    className='bg-[#9155FD] w-full'
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{padding: ".8rem 0", bgcolor: "#1e40af", "&:hover": {bgcolor: "#1e3a8a"}}}
                >
                    Register
                </Button>
            </Grid>
        </Grid>
      </form>

        <div className='flex justify-center flex-col items-center'>
            <div className='py-3 flex items-center'>
                <p className='text-white'>If you have already account ?</p>
                <Button 
                    onClick={() => navigate("/login")} 
                    className='ml-5' size='small'
                >
                    Login
                </Button>
            </div>
        </div>

        <div className='text-white'>
            <Divider>OR</Divider>
        </div>
      
        <Grid item xs={12}>
            <Button
                variant='outlined'
                fullWidth
                endIcon={<Google />}
            >
                Continue With Google
            </Button>
        </Grid>
    </div>
  )
}

export default Register
